import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

import storage from '../../lib/storage'
import { STATUS_LIVE } from '../../utils/constants'

import { loginWithHash } from '../../lib/api'
import { loadExamSource } from '../../utils/load-exam-source'
import { useParams } from 'react-router-dom'
import Player from '../../components/player'

const StyledContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: black;
`

const EmbedPlayer = () => {
    const [patient, setPatient] = useState()
    const { exam, hash } = useParams()

    useEffect(() => {
        startingRequests()
    }, [])
    const startingRequests = async () => {
        try {
            await getShareTokenFromApi()
            const result = await loadExamSource()
            if (!result) return
            if (result.paymentRedirect) {
                redirect(result.paymentRedirect)
                return
            }
            setPatient(result.patient)
        } catch (error) {
            console.log(error)
        }
    }

    const redirect = (url) => {
        if (typeof window !== 'undefined' && url) {
            window.location.href = url
        }
    }

    const getShareTokenFromApi = async () => {
        try {
            const { data } = await loginWithHash({ exam, hash })
            storage.saveSession(data)
        } catch (error) {
            console.error('Erro no login com hash:', error)
        }
    }

    return (
        <StyledContainer>
            {patient ? (
                <Player
                options={{
                    sources: [
                    { src: patient.intro, type: 'video/mp4' },
                    { src: patient.src, type: patient.type },
                    ],
                }}
                isLive={patient.examStatus === STATUS_LIVE}
                hlsjsConfig={{ maxMaxBufferLength: 12 }}
                />
            ) : (
                <p style={{ color: 'white', padding: 16 }}>Carregando...</p>
            )}
        </StyledContainer>
    )
}

export default EmbedPlayer
